import React from 'react';
import Alert from 'react-bootstrap/Alert';
import { useAlert } from '../../contexts';

const Alerts = () => {
    const { alert } = useAlert();
    if (!alert.show) return null;

    return (
        <Alert variant={alert.variant} className='alerts'>
            <Alert.Heading>{alert.heading}</Alert.Heading>
            <p>
                {alert.message}
            </p>

        </Alert>
    );
};

export default Alerts;
